<template>
  <TableLayout :permissions="['business:memberrides:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="车辆编号" prop="bikeCode">
        <el-input v-model="searchForm.bikeCode" placeholder="请输入车辆编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="openid" label="用户" min-width="180px" align="center"></el-table-column>
        <el-table-column prop="bikeCode" label="车辆编号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="bikeType" label="车辆类型" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="rideTime" label="借出时长" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="duration" label="计费时长" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="rentDate" label="借出时间" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="backDate" label="归还时间" min-width="100px" align="center"></el-table-column>
        <el-table-column label="操作" min-width="100px" align="center">
          <!-- 0未结算 1已结束 -->
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaReductionActionWindow.open('修改计费时长',row)">修改计费时长</el-button>
          </template>
        </el-table-column>

      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <OperaReductionActionWindow ref="operaReductionActionWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaReductionActionWindow from '@/components/business/OperaReductionActionWindow.vue'
export default {
  name: 'MemberRides',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaReductionActionWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        bikeCode: '',
        status: '2',
        closeStatus: '0',
        
      },
      value1: []
    }
  },
  created () {
    this.config({
      module: '用户骑行记录表',
      api: '/business/memberRides',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    returnAction(row) {
      
    }
  },
}
/**
 * 
 */
</script>
